export const columnsDataUsers = [
  {
    Header: "NAME",
    accessor: "companyName",
  },
  {
    Header: "EMAIL",
    accessor: "email",
  },
  {
    Header: "CREATED AT",
    accessor: "createdAt",
  },
  {
    Header: "STATUS",
    accessor: "status",
  },
  {
    Header: "ACTION",
    accessor: "action",
  },
];
